import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        css: css`
            width: unset;
            padding: 2px 15px 0 0;
            font-size: 12px;
            font-weight: normal;
            font-style: italic;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: auto;
        `,
        formField: css`
            width: 220px;
            align-items: center;
            justify-content: center;
        `,
        inputSelect: css`
            font-size: 12px;
            height: 30px;
            &+span {
                padding-top: 0;
            }
        `,
    },
};